import React from 'react'; 
import { Link, useLocation } from 'react-router-dom';

export default function Header({ onAssignmentClick }) {
  // Check if user is logged in
  const isLoggedIn = localStorage.getItem('loggedInUserId') !== null;
  const location = useLocation() //get the current location

  // Check if the current page is the dashboard page
  const isDashboardPage = location.pathname === '/dashboard';

  return (
    <nav className="navbar navbar-expand-lg" style={{ backgroundColor: '#1579e6' }}>
      <div className="container-fluid">
        <Link to="/">
          <img src="images/logofs.png" alt="logo" width="100" height="70" className="d-inline-block align-top" />
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-between" id="navbarNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/">Courses</Link>
            </li>
            {/* Render the Assignments only on the Dashboard page */}
            {isDashboardPage && (
              <li className="nav-item">
                <a className="nav-link" href="#" onClick={e => { e.preventDefault(); onAssignmentClick(); }}>
                  Assignments
                </a>
              </li>
            )}
            <li className="nav-item">
              <a className="nav-link" href="https://freshskills.co/about/" target="_blank" rel="noopener noreferrer">About</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="https://freshskills.co/contact/" target="_blank" rel="noopener noreferrer">Contact</a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/profile">Profile</Link>
            </li>
          </ul>
          {/* Conditionally render Login or Logout button based on the loggedInUserId in localStorage */}
          {isLoggedIn ? (
            <Link to="/logout" className="btn btn-danger ms-3">Logout</Link>
          ) : (
            <Link to="/login" className="btn btn-warning ms-3">Login Now</Link>
          )}
        </div>
      </div>
    </nav>
  );
}
